import React, { useEffect, useState } from "react";
import { UrlInternal } from "common/constants/endpoints";
import CardNewLetter from "components/CardNewLetter";
import { useHistory } from "react-router-dom";
import * as S from "./style";

interface Props {
  data?: any;
  artInside: any;
}

function ArtNewSletter({ data = [], artInside = [] }: Props) {
  const history = useHistory();
  const [tab, setTab] = useState<string>("newsletter");
  const [activeTab, setActiveTab] = useState<string | null>(null);
  const [activeImg, setActiveImg] = useState<string>("");
  const [list, setList] = useState<any[]>([]);
  const [link, setLink] = useState<string>(UrlInternal.NEWS_LETTER_LIST);

  useEffect(() => {
    const source = tab === "artInside" ? artInside : data;
    if (!Array.isArray(source) || source.length === 0) return;

    setList(source);
    setActiveImg(source[0]?.thumbnail || "");

    tab === "artInside"
      ? setLink(UrlInternal.ART_INSIGHT)
      : setLink(UrlInternal.ROUTES_NEWS_LETTER_DETAIL);
  }, [tab, data, artInside]);

  const handleMore = () => {
    if (tab === "artInside") {
      history.push(UrlInternal.ART_INSIGHT);
    } else {
      history.push(UrlInternal.NEWS_LETTER_LIST);
    }
  };

  return (
    <S.ArtNewSletter>
      <div className="wrapper">
        <img className="img" src={activeImg}></img>
        <div className="content">
          <div className="tabs">
            <div
              className={`newsletter${
                tab === "newsletter" || activeTab === "newsletter"
                  ? " active"
                  : ""
              }`}
              style={
                tab === "newsletter" || activeTab === "newsletter"
                  ? { zIndex: 1 }
                  : { zIndex: 0 }
              }
              onClick={() => setTab("newsletter")}
              onMouseEnter={() => setActiveTab("newsletter")}
              onMouseLeave={() => setActiveTab(null)}
            >
              뉴스레터
            </div>
            <div
              className={`artInside${
                tab === "artInside" || activeTab === "artInside"
                  ? " active"
                  : ""
              }`}
              style={
                tab === "artInside" || activeTab === "artInside"
                  ? { zIndex: 1 }
                  : { zIndex: 0 }
              }
              onClick={() => setTab("artInside")}
              onMouseEnter={() => setActiveTab("artInside")}
              onMouseLeave={() => setActiveTab(null)}
            >
              아트인사이드
            </div>
          </div>
          <div className="list">
            {list.map((v: any, i: any) => (
              <CardNewLetter
                key={i}
                data={v}
                tab={tab}
                goToDetail={() => {
                  history.push(`${link}/${v?.id}`);
                }}
                onMouseEnter={() => {
                  setActiveImg(v?.thumbnail);
                }}
                onMouseLeave={() => {
                  const source = tab === "artInside" ? artInside : data;
                  setActiveImg(source?.[0]?.thumbnail || "");
                }}
              />
            ))}
          </div>
          <div className="more-btn" onClick={handleMore}>
            MORE <span className="arrow">&gt;</span>
          </div>
        </div>
      </div>
    </S.ArtNewSletter>
  );
}

export default ArtNewSletter;
